import imagesLoaded from "imagesloaded"
import InfiniteScroll from "infinite-scroll"

export class Ias {
  constructor(element, msnry) {
    this.infScroll = {}
    this.options = {
      path: ".pageMoreNav",
      append: ".articleCardBig",
      history: true,
      status: ".page-load-status",
      checkLastPage: true,
      outlayer: msnry,
      loadOnScroll: false,
      button: ".pageMore button"
    }
    this.element = element
  }

  init() {
    InfiniteScroll.imagesLoaded = imagesLoaded
    this.infScroll = new InfiniteScroll(this.element, this.options)
  }
  reinit() {
    this.infScroll.destroy()
    this.init()
  }
}
